import { render } from "./CardPedidoList.vue?vue&type=template&id=6c4236c3"
import script from "./CardPedidoList.vue?vue&type=script&lang=js"
export * from "./CardPedidoList.vue?vue&type=script&lang=js"

import "./CardPedidoList.vue?vue&type=style&index=0&id=6c4236c3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__